/**
 * TODO: use data attribute to determine this vs hardcoded vals.
 * 
 * @param {int} clubId 
 * @returns bool - whether the club should show this checkbox
 */
function audienceTargetingEnabled( clubId ) {
    return [
        //41,  // Quebec EN
        //123, // Quebec FR
        //CAA requested the audience targeting checkbox be turned off for QC in 2024, we are preserving the ability to reactivate it if needed
    ].includes( clubId );
}

export {
    audienceTargetingEnabled
};
